export const DEFAULT_WIDTHS = {
  min: 200,
  max: 400,
}

export enum SidebarDirection {
  vertical,
  horizontal,
}
